import styled from "styled-components";

export const PricingComponentMainDiv = styled.main``;

interface PricingComponentHeroDivProp {
  isMonthly: boolean;
}
export const PricingComponentHeroDiv = styled.section<PricingComponentHeroDivProp>`
  padding: 200px 40px 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  > div {
    max-width: 1140px;
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  .pricing-hero-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    align-items: center;
  }
  .pricing-header-container {
    display: flex;
    flex-direction: column;
    gap: 60px;
    width: 100%;
    align-items: center;
  }
  .pricing-text-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    align-items: center;
    justify-content: center;
    max-width: 830px;
  }
  .pricing-text-wrapper {
    text-align: center;
    > h1 {
      text-align: center;
      font-size: 76px;
      font-weight: 500;
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
    }
  }

  .pricing-buttons-container {
    border: 1px solid rgb(25, 25, 25);
    border-radius: 8px;
    display: flex;
    cursor: pointer;
    gap: 10px;
    padding: 4px;
    transition: all 0.6s;

    > div {
      display: flex;
      cursor: pointer;
      aling-items: center;
      gap: 10px;
      &:before {
        content: "";
        width: 100px;
        transition: all 0.3s;
        height: 100%;
        position: absolute;
        background: white;
        left: ${(p) => (p.isMonthly ? "0" : "114px")};
        width: ${(p) => (p.isMonthly ? "104px" : "86px")};
        border-radius: 4px;
      }
    }
  }

  .pricing-Monthly-button-wrapper {
    > div {
      > p {
        color: ${(p) => (p.isMonthly ? "black" : "white")};
      }
    }
  }

  .pricing-yearly-button-wrapper {
    > div {
      > p {
        color: ${(p) => (!p.isMonthly ? "black" : "white")};
      }
    }
  }
  .pricing-button-wrapper {
    display: flex;
    > div {
      color: black;
      padding: 4px 20px;
      min-width: 84px;
      border-radius: 4px;

      > p {
        font-size: 16px;
        font-weight: 500;

        line-height: 1.4em;
      }
    }
  }
  .pricing-cards-container {
    z-index: 1;
    flex: none;
    grid-template-rows: repeat(1fr, min-content);
    grid-template-columns: repeat(3, minmax(200px, 1fr));
    grid-auto-rows:1fr;
    justify-content: center;
    gap: 24px;
    width: 100%;
    height: min-content;
    padding: 0;
    display: grid;
   
`;

export const PricingComponentCardDiv = styled.div<PricingComponentHeroDivProp>`
  place-self: start;
  display:flex;
  width: 100%;
  min-width:200px;
  height: 100%;
  overflow: hidden;
  border-radius: 16px;
  .pricing-card-gradient {
    background: linear-gradient(
  90deg,
   rgb(255, 223, 125)  39%,    /* The Rich Base: Vibrant Gold */
  rgb(195, 220, 250) 60%,   /* The Metallic Flash: Icy Periwinkle */
  rgb(80, 140, 245) 79%     /* The Deep Pop: Vivid Cornflower Blue */
);
    filter: blur(93px);
    position: absolute;
    width: 100%;
    height: 185px;
    top: -228px;
    left: 0;
  }
  .pricing-card-popular-tag {
    border-radius: 12px;
    background:rgba(255, 222, 125, 0.87)  ;
    width: fit-content;
    padding: 4px 8px;
    position: absolute;
    top: -12px;
    right: -12px;

    > p {
      font-size: 15px;
      text-transform: uppercase;
      line-height: 1em;

      font-weight: 500;
    }
  }

  > div {
    border: 1px solid rgb(25, 25, 25);
    border-radius: 16px;
    padding: 32px;
    display: flex;
    flex-direction: column;
  }
  .pricing-card-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  .pricing-card-header-container {
    display: flex;
    flex-direction: column;
    gap: 60px;
  }
  .pricing-card-header-text-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .pricing-card-header-text-wrapper {
    display: flex;
    flex-direction: column;
    > h2 {
      margin: 0;
      padding: 0;
      font-size: 28px;
      font-weight: 500;
    }
    > p {
      font-size: 17px;
      font-weight: normal;
      color: #fff;
    }
  }
  .pricing-card-price-cotainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
    > div {
      width: 100%;
    }
  }
  .pricing-card-button-cotainer {
    text-align: center;
  }
  .pricing-card-price-wrapper {
    display: flex;
    gap: 4px;
    align-items: end;
  }
  .pricing-card-price-text-wrapper {
  display:flex;
  align-items:end;
    > h3 {
      font-size: 44px;
      font-weight: 600;
      line-height: 1.2em;
    }
    > p {
      line-height: 1.5em;
      opacity: 0.7;
      padding-bottom: 6px;
    }
  }
  .pricing-card-line {
    width: 100%;
    background: #fff;
    opacity: 0.15;
  }
  .pricing-card-bottom-container {
    display: flex;
    gap: 16px;
    width: 100%;
    flex: 1;
    flex-flow: column;
  }
  .pricing-card-feature-container {
    display: flex;
    gap: 12px;
    align-items: center;
  }
  .pricing-card-icon-container {
    width: 20px;
    height: 20px;
    > svg {
      fill: url(#shinyTransparentGray);

      width: 20px;
      height: 20px;
    }
  }
  .pricing-card-text-container {
    > p {
      font-weight: 500;
      font-size: 17px;
    }
  }
  .pricing-card-feature-text-wrapper {
    opacity: 0.7;
    > p {
      font-weight: normal;
      font-size: 16px;
    }
  }
  .pricing-card-text-wrapper {
    height: 53px;
    overflow: hidden;
    display: flex;
    flex-flow: column;
  }
  .price-label-2,
  .price-label {
  transition:all .6s;
    transform: ${(p) => (!p.isMonthly ? " translateY(-53px)" : "none")};
  }
  .price-label-2 {
    opacity: ${(p) => (!p.isMonthly ? "1" : "0")};
  }
  .price-label {
    opacity: ${(p) => (p.isMonthly ? "1" : "0")};
  }
`;
